import { Redirect, Route } from "react-router-dom";

// export { PrivateRoute };

function PrivateRoute({ component: Component, ...rest }: any) {

  // const user = useSelector((state: RootStateOrAny) => state.user);

  let isUserLogged = localStorage.getItem('user');

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isUserLogged === null) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }

        // authorized so return component
        return <Component {...props} />;
      }}
    />
  );
}

export default PrivateRoute;
